import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import SkillsTab from './SkillsTab';
import SujetsTab from './SujetsTab';
import PreconisationsTab from './PreconisationsTab';

/** L'onglet « Bac » (ou « Brevet ») de l'app élève, tel que l'élève le voit, pour la page Élèves de l'enseignant. */
export default function StudentBacPanel({ studentId }: { studentId: number }) {
  const [tab, setTab] = useState(0);
  return (
    <Box>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="fullWidth" sx={{ mb: 2 }}>
        <Tab label="Savoir-faire" />
        <Tab label="Sujets" />
        <Tab label="Préconisations" />
      </Tabs>
      {tab === 0 && <SkillsTab studentId={studentId} />}
      {tab === 1 && <SujetsTab studentId={studentId} />}
      {tab === 2 && <PreconisationsTab studentId={studentId} />}
    </Box>
  );
}
